
import React from "react";
const defaultTokenContext: any = {}
export const TokenContext = React.createContext(defaultTokenContext);